import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import { getCookie, CookieName, setCookie } from "../utils/cookieManager";
// import Radio from "@material-ui/core/Radio";
// import FormControl from "@material-ui/core/FormControl";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
// import { Config } from "../utils/Config";
// import OutlinedInput from "@material-ui/core/OutlinedInput";
// import InputMask from "react-input-mask";
import CircularProgress from "@material-ui/core/CircularProgress";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import TextField from "@material-ui/core/TextField";
// import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import "../App.scss";

const styles = () => ({
  root: {
    border: "none",
    boxShadow: "none",
    padding: "2px",
    backgroundColor: "#fafafa"
  },
  expansionPanelSummaryContent: {
    display: "block",
    margin: "0 !important"
  },
  expansionPanelDetailContent: {
    padding: "8px"
  },
  radioBtnStyle: {
    paddingRight: "12px !important",
    paddingLeft: 0
  },
  textField: {
    marginTop: 0
  },
  paperStyle: {
    padding: "16px"
  },
  dialogCustomizedWidth: {
    "max-width": "95%",
    margin: "1rem"
  }
});

const getQueryParams = (name, url) => {
  // debugger;
  if (!url) {
    const blockRes = this.props.location.state.blockRes;
    url = blockRes.bookingUrl;
  }

  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results === null ? "" : results[1];
};

class TicketSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSnackBarOpen: false,
      isShowFareDetail: false,
      paymentGateway: "payu",
      walletPoints: 0,
      travelInsuranceCharge: 0,
      finalPayableAmount: 0,
      selectedPaymentMethod: "",
      dcNumber: "",
      dcNumberErr: false,
      dcNumberErrTxt: "",
      dcExpMonth: "",
      dcExpMonthErr: false,
      dcExpMonthErrTxt: "",
      dcExpYear: "",
      dcExpYearErr: false,
      dcExpYearErrTxt: "",
      dcCVV: "",
      dvCVVErr: false,
      dcCVVErrTxt: "",
      dcName: "",
      dcNameErr: false,
      dcNameErrTxt: "",
      ccNumber: "",
      ccNumberErr: false,
      ccNumberErrTxt: "",
      ccExpMonth: "",
      ccExpMonthErr: false,
      ccExpMonthErrTxt: "",
      ccExpYear: "",
      ccExpYearErr: false,
      ccExpYearErrTxt: "",
      ccCVV: "",
      ccCVVErr: false,
      ccCVVErrTxt: "",
      ccName: "",
      ccNameErr: false,
      ccNameErrTxt: "",
      bankcode: "",
      netBankingList: {},
      gPayBankHandle: "",
      gPayBankHandleErr: false,
      gPayBankHandleErrTxt: "",
      upiBankHandle: "",
      upiBankHandleErr: false,
      upiBankHandleErrTxt: "",
      isloading: false,
      isGobackDialogOpen: false,
      cardMask: {
        mask: "9999 9999 9999 9999"
      },
      cardType: "",
      isDialogOpen: false
    };

    this.MAX_RETRY = 4;
    this.RETRY_INTERVAL_MS = 3000; //ms

    this.retryCount = 0;

    this.payPhonePe = this.payPhonePe.bind(this);
    this.pollStatusApi = this.pollStatusApi.bind(this);
  }

  getPhonePeTransactionId = prebookingId => {
    const toPayInPaise = this.state.finalPayableAmount * 100;
    const url = `https://securedapi.confirmtkt.com/api/platform/phoneUserInitiatetransaction?amount=${toPayInPaise}&transactionId=${prebookingId}&type=bus`;
    return fetch(url);
  };

  //call api at certain interval without stacking // time in miliseconds
  pollStatusApi = (url, timeMs = 2000, prebookingId, redirectUrl) => {
    this.setState({ isloading: true });
    this.retryCount++;
    const networkPromise = fetch(url);
    let timeOutPromise = new Promise(function(resolve, reject) {
      setTimeout(resolve, timeMs, "Timeout Done");
    });

    const promises = [networkPromise, timeOutPromise].map(p =>
      p.then(res => {
        if (res.json) {
          return res.json();
        } else {
          return res;
        }
      })
    );
    Promise.all(promises)
      .then(([np, tp]) => {
        const status = np;
        console.log("Payment Status:", status);
        if (!status.Error && status.success) {
          //payment success
          window.location.replace(redirectUrl);
        } else {
          console.log("Payment failed");
          //Repeat
          if (this.retryCount <= this.MAX_RETRY) {
            this.pollStatusApi(
              url,
              this.RETRY_INTERVAL_MS,
              prebookingId,
              redirectUrl
            );
          } else {
            this.setState({ isloading: false });
            window.location.replace(
              `https://www.confirmtkt.com/bus-booking-phonepe/transaction-fail?error=Payment failed`
            );
          }
        }
      })
      .catch(err => {
        console.log("status polling error", err);
        this.setState({ isloading: false });
        window.location.replace(
          `https://www.confirmtkt.com/bus-booking-phonepe/transaction-fail?error=Could not connect to server`
        );
      });
  };

  payPhonePe = (redirectUrl, prebookingId) => {
    this.setState({ isloading: true });
    //let operatingSystem = window.PhonePe.Constants.OS.android;
    window.PhonePe.PhonePe.loggingEnabled = true;
    window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web).then(
      sdk => {
        this.getPhonePeTransactionId(prebookingId)
          .then(transactionIdRes => transactionIdRes.json())
          .then(transactionIdRes => {
            const transactionId = transactionIdRes.data.reservationId;
            console.log("transaction ID - " + transactionId);
            console.log("prebookingId - " + prebookingId);
            sdk
              .proceedToPay(
                transactionId,
                "https://www.confirmtkt.com/train-booking-phonepe"
              )
              .then(response => {
                console.log("Payment was successful = " + response);
                const url = `https://securedapi.confirmtkt.com/api/platform/trainbooking/checkAndDeductPayment?transactionId=${prebookingId}&paymentprovider=PHONEPE-S&client=true&type=bus`;
                this.pollStatusApi(
                  url,
                  this.RETRY_INTERVAL_MS,
                  prebookingId,
                  redirectUrl
                );
              })
              .catch(err => {
                console.log("Payment failed");
                //alert("payment failed");
                this.props.history.goBack();
                this.setState({ isloading: false });
              });
          });
      }
    );
  };

  removeDisabledBtn = () => {
    const element = document.getElementsByClassName("ctkt-btn-success-bottom");
    element[0].classList.remove("disabled", "opacity");
  };

  addDisabledBtn = () => {
    const element = document.getElementsByClassName("ctkt-btn-success-bottom");
    element[0].classList.add("disabled", "opacity");
  };

  componentDidMount() {
    // When User wants to go back
    // window.history.pushState(null, null, window.location.href);
    // window.onpopstate = () => {
    //   console.log("Going Back");
    //   this.setState({
    //     isGobackDialogOpen: true
    //   });
    //   window.history.go(1);
    // };

    if (!getCookie("TicketSummaryVisit")) {
      setCookie("TicketSummaryVisit", true);
    } else {
      this.props.history.goBack();
    }

    const blockRes = this.props.location.state.blockRes;
    const travelInsurance = this.props.location.state.travelInsurance;
    const passengercount = this.props.location.state.blockTicketrequest
      .inventoryItems.length;
    // console.log(passengercount);

    this.setState({
      travelInsuranceCharge: travelInsurance ? 15 * passengercount : 0
    });
    const token = getCookie(CookieName.USERTOKEN);
    // const phone = this.props.ticketdetailsReducer.mobile;
    const totalamount = getQueryParams("totalFare", blockRes.pgURL);
    const url = `https://securedapi.confirmtkt.com/api/platform/trainbooking/GetWalletPoints?userKey=${token}`;
    fetch(url)
      .then(res => res.json())
      .then(res => {
        console.log(res);

        // toFixed will return a string
        const twoDecimal = res.Points
          ? parseFloat(parseFloat(res.Points / 100).toFixed(2))
          : 0;
        //totalamount = totalamount - twoDecimal;
        let finalPayableAmount =
          totalamount - twoDecimal + this.state.travelInsuranceCharge;
        if (totalamount <= twoDecimal) {
          finalPayableAmount = 0;
        }
        this.setState({
          walletPoints: twoDecimal,
          totalamount: totalamount,
          finalPayableAmount
        });
      })
      .catch(error => {
        this.openSnackBar("Unable to get wallet points");
        console.error("Error:", error);
      });

    const getNetBankingStatusURL =
      "https://securedapi.confirmtkt.com/api/platform/getNetbankingStatusPayu";

    fetch(getNetBankingStatusURL)
      .then(response => response.json())
      .then(res => {
        const netBankingList = Object.keys(res)
          .sort()
          .reduce((accumulator, currentKey) => {
            if (res[currentKey].up_status === 1) {
              accumulator[currentKey] = res[currentKey];
            }
            return accumulator;
          }, {});

        let bankcode;
        if (Object.keys(netBankingList).length > 0) {
          bankcode = netBankingList[Object.keys(netBankingList)[0]].ibibo_code;
        } else {
          bankcode = "";
        }

        this.setState({ netBankingList, bankcode });
        //console.log(netBankingList);
      });
  }

  handleDialogClose = () => {
    this.setState({
      isDialogOpen: false,
      isGobackDialogOpen: false
    });
  };

  handleDialogOpen = () => {
    this.setState({
      isDialogOpen: true
    });
  };

  postData = (url = "", data = {}) => {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    }).then(response => response.json());
  };

  openSnackBar = message => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({ isSnackBarOpen: true, message: msg });
  };

  handleClose = () => {
    this.setState({ isSnackBarOpen: false });
  };

  redirectWithPost = (url, data) => {
    // debugger;
    const formElement = document.createElement("form");
    formElement.name = "redirectWithPost";
    formElement.method = "POST";
    formElement.action = url;

    if (data) {
      Object.keys(data).forEach(key => {
        const inputElement = document.createElement("input");
        inputElement.type = "hidden";
        inputElement.name = key;
        inputElement.value = data[key];
        formElement.appendChild(inputElement);
      });
      document.body.appendChild(formElement);
      formElement.submit();
    }
  };

  redirectPayment = () => {
    const provider = this.props.searchQuery.seatapidata.bus.Provider;
    const finalPayableAmount = this.state.finalPayableAmount;
    const blockRes = this.props.location.state.blockRes;
    const tempToken = getCookie(CookieName.USERTEMPTOKEN);
    const prebookingId = getQueryParams("prebookingid", blockRes.pgURL);
    const amount = getQueryParams("totalFare", blockRes.pgURL);
    const name = getQueryParams("name", blockRes.pgURL);
    const phone = getQueryParams("phone", blockRes.pgURL);
    const email = getQueryParams("email", blockRes.pgURL);

    if (finalPayableAmount > 0) {
      //----- phonepe sdk -------//
      const redirectUrl = `https://www.confirmtkt.com/Booking/phonepe-switch/bus/paymentSuccess.php?txnid=${prebookingId}&busProvider=${provider}&email=${email}`;
      if (!window.PhonePe) {
        this.addDisabledBtn();
        const script = document.createElement("script");
        script.src =
          "https://www.confirmtkt.com/phonepe-js-sdk-0.3.17/bundle.js";
        script.async = true;

        script.onload = () => {
          this.payPhonePe(redirectUrl, prebookingId);
        };
        document.body.appendChild(script);
      } else {
        this.payPhonePe(redirectUrl, prebookingId);
      }

      //----- phonepe sdk ends -------//
    } else {
      //full wallet
    }
  };

  render() {
    const blockRes = this.props.ticketdetailsReducer;
    // const passenger = blockRes.passengerdetails;
    const bus = blockRes.bus;
    const boarding = blockRes.boarding;
    const JourneyDetails = this.props.searchQuery;
    const from = JourneyDetails.source.city;
    const to = JourneyDetails.destination.city;
    const doj = JourneyDetails.doj;
    const { walletPoints, finalPayableAmount } = this.state;
    const { classes } = this.props;

    var date = new Date(doj);
    let boardingPt = boarding.Time + " " + boarding.Name;
    //console.log(dropping.Time);
    var DepartureTime = bus.DeparturePoints[0].Time.split(":");
    var boardingTime = boarding.Time.split(":");
    if (DepartureTime[0] > boardingTime[0]) {
      date = new Date(doj);
      date.setDate(date.getDate() + 1);
      console.log(date);
    }

    const GobacktoSeatLayout = (
      <Dialog
        open={this.state.isGobackDialogOpen}
        onClose={this.handleDialogClose}
        maxWidth="xl"
        fullWidth
      >
        <div className="fare-details">
          <h4>Are You sure You Want to go back ?</h4>
          <hr />
          <br />
          <Grid container justify="flex-start" className="fare-details-content">
            <span style={{ fontSize: "14px" }}>
              Your selected seats are Already Blocked! You need to Select
              Different Seats if you go back.
            </span>
            <br />
            <span>
              Note: Your selected seats will be available after a While.
            </span>
            <Grid item xs={12} className="text-right">
              <button
                style={{ margin: "5px" }}
                className="btn btn-default "
                onClick={this.handleDialogClose}
              >
                Cancel
              </button>
              <button
                style={{ margin: "5px" }}
                className="btn btn-success "
                onClick={e => this.props.history.goBack()}
              >
                Go Back
              </button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );

    const fareDetailsDialog = (
      <Dialog
        open={this.state.isDialogOpen}
        onClose={this.handleDialogClose}
        maxWidth="xl"
        fullWidth
        classes={{ paperFullWidth: classes.dialogCustomizedWidth }}
      >
        <div className="fare-details">
          <h3>Fare Details</h3>
          <hr />
          <Grid container justify="flex-start" className="fare-details-content">
            <Grid item xs={6}>
              Ticket Fare
            </Grid>
            <Grid item xs={6} className="right-column">
              &nbsp;&nbsp;:&nbsp;&nbsp;₹ {this.state.totalamount}
            </Grid>
            <Grid item xs={6}>
              Wallet Points
            </Grid>
            <Grid item xs={6} className="right-column">
              &nbsp;&nbsp;:&nbsp;&nbsp;₹{this.state.walletPoints}
            </Grid>
          </Grid>
          <Grid container className="grand-total-container">
            <Grid item xs={6}>
              <span className="total-fare">Grand Total</span>
              <br />
              <span>Inclusive of GST</span>
            </Grid>
            <Grid item xs={6} className="right-column">
              <span className="total-fare">
                &nbsp;&nbsp;:&nbsp;&nbsp;₹ {this.state.finalPayableAmount}
              </span>
            </Grid>
            <Grid item xs={12} className="text-right">
              <strong
                className="close-dialog-btn"
                onClick={this.handleDialogClose}
              >
                Close
              </strong>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );

    let displayBlock = <div />;

    // || !blockRes.avlDayList || blockRes.avlDayList.length === 0
    if (!blockRes) {
      displayBlock = (
        <div className="error-message">
          <i class="material-icons">error_outline</i> <br />
          Unable to block ticket
          <br />
          Please try after some time
        </div>
      );
    } else {
      displayBlock = (
        <div>
          <div className="ticket-summary-container">
            <div>
              <div className="route" style={{ fontSize: "14px" }}>
                <Grid container justify="flex-start">
                  <Grid item xs={8} className="title">
                    <span>{bus.TravelsName}</span>
                  </Grid>
                </Grid>

                <Grid container justify="flex-start">
                  <Grid item xs={6}>
                    <span>{from}</span>
                  </Grid>
                  <Grid item xs={1}>
                    <i className="material-icons">arrow_right_alt</i>
                  </Grid>
                  <Grid item xs={5} className="right-column">
                    <span>{to}</span>
                  </Grid>
                </Grid>
                <hr />
                <Grid container justify="flex-start">
                  <Grid item xs={5}>
                    <span>Boarding Date</span>
                  </Grid>
                  <Grid item xs={7} className=" ">
                    {date.toDateString()}
                  </Grid>
                </Grid>
                <Grid container justify="flex-start">
                  <Grid item xs={5}>
                    <span>Boarding Point</span>
                  </Grid>
                  <Grid item xs={7} className=" ">
                    {boardingPt}
                  </Grid>
                </Grid>
              </div>

              <hr />

              {walletPoints > 0 ? (
                <div>
                  <Grid container justify="flex-start">
                    <Grid item xs={6}>
                      <span className="total-fare">Wallet Balance</span>
                    </Grid>
                    <Grid item xs={6} className="right-column">
                      <span className="total-fare">₹ {walletPoints}</span>
                    </Grid>
                  </Grid>
                  <hr />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    }

    const bottommenu = (
      <div className="bottom-fixed-details">
        <Grid container>
          <Grid
            item
            xs={6}
            onClick={this.handleDialogOpen}
            className="fare-info"
          >
            <div>
              <span>To Pay:&nbsp;&nbsp;</span>
              <span style={{ fontSize: "2rem" }}>
                &#8377;&nbsp;{finalPayableAmount}
              </span>
            </div>
            <div style={{ position: "relative" }}>
              <span className="sm-text">Fare Details</span>
              <i className="material-icons">help_outline</i>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div
              variant="contained"
              style={{ padding: "2rem" }}
              className="ctkt-btn-success-bottom"
              onClick={() => this.redirectPayment()}
            >
              CONTINUE
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const header = (
      <Grid container justify="flex-start" className="header-summary">
        <Grid item xs={1} className="backBtn">
          <i
            className="material-icons"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            arrow_back
          </i>
        </Grid>
        <Grid item xs={10}>
          <div className="title">
            <span>Ticket Summary</span>
          </div>
        </Grid>
      </Grid>
    );

    return (
      <div className="ticket-summary">
        {header}
        {fareDetailsDialog}
        {GobacktoSeatLayout}

        {this.state.isloading ? (
          <div className="loading fixed">
            <CircularProgress />
          </div>
        ) : (
          ""
        )}

        {displayBlock}
        {bottommenu}
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={4000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ticketdetailsReducer: state.ticketdetailsReducer,
    searchQuery: state.searchReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

TicketSummary.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TicketSummary));
